import { passiveOption } from './passiveOption';

export function addEvents(el, obj) {
  for (var prop in obj) {
    var option = (prop === 'touchstart' || prop === 'touchmove') ? passiveOption : false;
    el.addEventListener(prop, obj[prop], option);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/addEvents.js
// module id = 62
// module chunks = 0 1